import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  width: calc(50% - 6px);\n  height: calc(100% - 6px);\n  top: 3px;\n  left: ", ";\n  background-color: ", ";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 100px;\n  font-size: 14px;\n  font-weight: 600;\n  font-style: normal;\n  transition: all 0.3s ease-in 0s;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  width: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: ", ";\n  font-size: 14px;\n  font-weight: 600;\n  font-style: normal;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  display: flex;\n  vertical-align: middle;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  width: 100%;\n  min-height: 44px;\n  background-color: ", ";\n  border-radius: 100px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import PropTypes from 'prop-types';
import styled from '../utils/styling/styled-components';
var ToggleSwitchWrapper = styled.div(_templateObject(), function (props) {
  return props.theme.colors.ivory;
});
var ToggleOption = styled.div(_templateObject2(), function (props) {
  return props.theme.colors.stone;
});
var ToggleSwitchHandler = styled.div(_templateObject3(), function (props) {
  return props.checked ? 'calc(50% + 3px)' : '3px';
}, function (props) {
  return props.theme.colors.white;
});

var ToggleSwitch = function ToggleSwitch(_ref) {
  var checked = _ref.checked,
      onChange = _ref.onChange,
      optionLabels = _ref.optionLabels;

  function handleKeyPress() {
    onChange(!checked);
  }

  return /*#__PURE__*/React.createElement(ToggleSwitchWrapper, {
    onClick: handleKeyPress
  }, /*#__PURE__*/React.createElement(ToggleOption, null, optionLabels[0]), /*#__PURE__*/React.createElement(ToggleOption, null, optionLabels[1]), /*#__PURE__*/React.createElement(ToggleSwitchHandler, {
    checked: checked
  }, checked ? optionLabels[1] : optionLabels[0]));
}; // Set optionLabels for rendering.


ToggleSwitch.defaultProps = {
  optionLabels: ['yes', 'no']
};
ToggleSwitch.propTypes = {
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  optionLabels: PropTypes.array
};
export { ToggleSwitch };